import { ProductRequestType } from "~/types/products-request-handler";

import {
  DEFAULT_PRODUCT_TYPE,
  SHOP_FILTER_DROPDOWN_QUERY,
} from "./shop-filter.const";

export const shopFilterPrepareQuery = (
  value: ProductRequestType,
): Record<string, unknown> | null => {
  const isQueryEmpty = value === DEFAULT_PRODUCT_TYPE || value === "";
  const filterParam = isQueryEmpty
    ? null
    : {
        salesChannel: {
          operator: "OR",
          values: SHOP_FILTER_DROPDOWN_QUERY[value],
        },
      };

  return filterParam;
};

export const queryToRemoveClickCollectExclusive = (
  isClickAndCollectEnabled: boolean,
): Record<string, unknown> | null => {
  return isClickAndCollectEnabled
    ? null
    : {
        salesChannel: {
          operator: "OR",
          values: ["Click and Collect Only"],
          not: true,
        },
      };
};
